export interface CategoryItem {
  key: string;
  name: string;
  icon: string;
  count: number;
  description: string;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    key: "都市",
    name: "都市情感",
    icon: "ri-building-2-line",
    count: 128,
    description: "聚焦职场与生活，写尽都市人的孤独与自愈。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20modern%20city%20skyline%20at%20blue%20hour%20with%20warm%20window%20lights%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%20flat%20lay%2C%20high%20detail&width=600&height=400&seq=cat-dushi-01&orientation=landscape",
  },
  {
    key: "古装",
    name: "古装权谋",
    icon: "ri-ancient-gate-line",
    count: 96,
    description: "朝堂江湖、家国天下，恢弘美术下的群像史诗。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20an%20ancient%20Chinese%20palace%20gate%20with%20red%20pillars%20and%20lanterns%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%20composition%2C%20high%20detail&width=600&height=400&seq=cat-guzhuang-02&orientation=landscape",
  },
  {
    key: "悬疑",
    name: "悬疑犯罪",
    icon: "ri-search-eye-line",
    count: 74,
    description: "抽丝剥茧的双线叙事，逼近不愿被触碰的真相。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20foggy%20city%20street%20at%20night%20with%20a%20single%20street%20lamp%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20high%20detail&width=600&height=400&seq=cat-xuanyi-03&orientation=landscape",
  },
  {
    key: "历史",
    name: "历史正剧",
    icon: "ri-book-2-line",
    count: 52,
    description: "个体命运与时代洪流交织，沉稳克制的镜语。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20ancient%20Chinese%20mountains%20in%20morning%20mist%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20painterly%20atmospheric%20composition%2C%20high%20detail&width=600&height=400&seq=cat-lishi-04&orientation=landscape",
  },
  {
    key: "青春",
    name: "青春校园",
    icon: "ri-graduation-cap-line",
    count: 88,
    description: "蝉鸣、操场与同学录，追忆最好的那一年。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20sunlit%20classroom%20with%20fluttering%20curtains%20and%20wooden%20desks%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20nostalgic%20atmospheric%2C%20high%20detail&width=600&height=400&seq=cat-qingchun-05&orientation=landscape",
  },
  {
    key: "科幻",
    name: "科幻冒险",
    icon: "ri-planet-line",
    count: 41,
    description: "硬核设定下的孤独与等待，远方的讯号。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20deep%20red%20space%20nebula%20with%20stars%20and%20a%20small%20spacecraft%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20high%20detail&width=600&height=400&seq=cat-kehuan-06&orientation=landscape",
  },
  {
    key: "喜剧",
    name: "喜剧家庭",
    icon: "ri-emotion-happy-line",
    count: 63,
    description: "鸡飞狗跳的日常里，藏着最踏实的温暖。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20cozy%20warm%20lit%20family%20dining%20room%20with%20festive%20decorations%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20heartwarming%20atmospheric%2C%20high%20detail&width=600&height=400&seq=cat-xiju-07&orientation=landscape",
  },
  {
    key: "武侠",
    name: "武侠江湖",
    icon: "ri-sword-line",
    count: 37,
    description: "刀光剑影之外，是与自己过去的和解。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20misty%20bamboo%20forest%20at%20dusk%20with%20falling%20leaves%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20atmospheric%20wuxia%20mood%2C%20high%20detail&width=600&height=400&seq=cat-wuxia-08&orientation=landscape",
  },
  {
    key: "商战",
    name: "商战职场",
    icon: "ri-line-chart-line",
    count: 45,
    description: "资本、道义与友情，在谈判桌上被反复称量。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20night%20city%20financial%20district%20from%20a%20high%20floor%20window%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20moody%20atmospheric%2C%20high%20detail&width=600&height=400&seq=cat-shangzhan-09&orientation=landscape",
  },
  {
    key: "谍战",
    name: "谍战年代",
    icon: "ri-spy-line",
    count: 29,
    description: "信仰与牺牲的重量，每一次传递都可能是最后一次。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20an%20old%20city%20street%20at%20night%20with%20rain%20and%20gaslights%2C%20deep%20red%20and%20dark%20gold%20color%20grading%2C%20tense%20noir%20atmospheric%2C%20high%20detail&width=600&height=400&seq=cat-diezhan-10&orientation=landscape",
  },
];